ACDiscountAppSubtotal.CartPage.Show_CalculateTier = function () {

    async function setDateTimeInCart() {
        //debugger
    try {
      const response = await fetch("/cart/update.js", {
        method: "POST",
        headers: {
          "X-Requested-With": "XMLHttpRequest",
          "Content-Type": "application/json",
        },
        body: JSON.stringify({
          attributes: {
            Discountly_dateTime: `${globalFieldsSub.Storetime()},${Shopify.shop}`,
          },
        }),
      });

      if (!response.ok) {
        throw new Error(`Error: ${response.statusText}`);
      }

      await response.json();
    } catch (error) {
      // console.error('Failed to update cart:', error);
    }
  }



    var UpdateCartItem = function (item, updatedItemPrice, updatedLinePrice, isUpdate, index) {
        if (isUpdate) {
            var originalItemPrice = globalFieldsSub.ConvertToFixedDecimalNumber(item.original_price / 100), originalLinePrice = globalFieldsSub.ConvertToFixedDecimalNumber(item.original_line_price / 100);
            var condition1 = updatedItemPrice == originalItemPrice;
            updatedItemPrice = globalFieldsSub.ConvertToFixedDecimalString(updatedItemPrice), updatedLinePrice = globalFieldsSub.ConvertToFixedDecimalString(updatedLinePrice);
            if (condition1) {
/* Uncomment for unit price strike off */
//                 jQuery('.cart__price dd[data-cart-item-regular-price]').eq(index).html('<div><span class="money" data-currency-' + globalFieldsSub.currency.toLowerCase() + '="' + globalFieldsSub.currencySymbol + updatedItemPrice + '" data-currency="' + globalFieldsSub.currency + '">' + globalFieldsSub.currencySymbol + updatedItemPrice + '</span></div>');
//                 jQuery('form[action="/cart"] tbody tr:eq(' + index + ') td:eq(3) div:first').html('<div><span class="money" data-currency-' + globalFieldsSub.currency.toLowerCase() + '="' + globalFieldsSub.currencySymbol + updatedLinePrice + '" data-currency="' + globalFieldsSub.currency + '">' + globalFieldsSub.currencySymbol + updatedLinePrice + '</span></div>');
            }
            else {
                originalItemPrice = globalFieldsSub.ConvertToFixedDecimalString(originalItemPrice), originalLinePrice = globalFieldsSub.ConvertToFixedDecimalString(originalLinePrice);
//                 jQuery('.cart__price dd[data-cart-item-regular-price]').eq(index).html('<s><span class="money" data-currency-' + globalFieldsSub.currency.toLowerCase() + '="' + globalFieldsSub.currencySymbol + originalItemPrice + '" data-currency="' + globalFieldsSub.currency + '">' + globalFieldsSub.currencySymbol + originalItemPrice + '</span></s></div> <div><span class="money" data-currency-' + globalFieldsSub.currency.toLowerCase() + '="' + globalFieldsSub.currencySymbol + updatedItemPrice + '" data-currency="' + globalFieldsSub.currency + '">' + globalFieldsSub.currencySymbol + updatedItemPrice + '</span>');
//                 jQuery('form[action="/cart"] tbody tr:eq(' + index + ') td:eq(3) div:first').html('<s><span class="money" data-currency-' + globalFieldsSub.currency.toLowerCase() + '="' + globalFieldsSub.currencySymbol + originalLinePrice + '" data-currency="' + globalFieldsSub.currency + '">' + globalFieldsSub.currencySymbol + originalLinePrice + '</span></s></div> <div><span class="money" data-currency-' + globalFieldsSub.currency.toLowerCase() + '="' + globalFieldsSub.currencySymbol + updatedLinePrice + '" data-currency="' + globalFieldsSub.currency + '">' + globalFieldsSub.currencySymbol + updatedLinePrice + '</span>');
            }
        }
    }

   
    var UpdateCartSubtotal = function (isUpdate, updatedTotalPrice, originalTotalPrice) {
        if (isUpdate) {
            updatedTotalPrice = globalFieldsSub.ConvertToFixedDecimalString(updatedTotalPrice), originalTotalPrice = globalFieldsSub.ConvertToFixedDecimalString(originalTotalPrice);
            if (originalTotalPrice != updatedTotalPrice) {
               // jQuery('.js-contents .totals .totals__subtotal-value').html('<s><span class="money" data-currency-' + globalFieldsSub.currency.toLowerCase() + '="' + globalFieldsSub.currencySymbol + originalTotalPrice + '" data-currency="' + globalFieldsSub.currency + '">' + globalFieldsSub.formatMoney(originalTotalPrice, globalFieldsSub.amount) + '</span></s> <span class="money" data-currency-' + globalFieldsSub.currency.toLowerCase() + '="' + globalFieldsSub.currencySymbol + updatedTotalPrice + '" data-currency="' + globalFieldsSub.currency + '">' + globalFieldsSub.formatMoney(updatedTotalPrice, globalFieldsSub.amount) + '</span>');
              // jQuery('.drawer__footer .cart-drawer__footer .totals .totals__subtotal-value').html('<s><span class="money" data-currency-' + globalFieldsSub.currency.toLowerCase() + '="' + globalFieldsSub.currencySymbol + originalTotalPrice + '" data-currency="' + globalFieldsSub.currency + '">' + globalFieldsSub.formatMoney(originalTotalPrice, globalFieldsSub.amount) + '</span></s> <span class="money" data-currency-' + globalFieldsSub.currency.toLowerCase() + '="' + globalFieldsSub.currencySymbol + updatedTotalPrice + '" data-currency="' + globalFieldsSub.currency + '">' + globalFieldsSub.formatMoney(updatedTotalPrice, globalFieldsSub.amount) + '</span>');
            }
            else {
             // jQuery('.js-contents .totals .totals__subtotal-value').html('<span class="money" data-currency-' + globalFieldsSub.currency.toLowerCase() + '="' + globalFieldsSub.currencySymbol + updatedTotalPrice + '" data-currency="' + globalFieldsSub.currency + '">' + globalFieldsSub.formatMoney(updatedTotalPrice, globalFieldsSub.amount) + '</span>');
              //jQuery('.drawer__footer .cart-drawer__footer .totals .totals__subtotal-value').html('<span class="money" data-currency-' + globalFieldsSub.currency.toLowerCase() + '="' + globalFieldsSub.currencySymbol + updatedTotalPrice + '" data-currency="' + globalFieldsSub.currency + '">' + globalFieldsSub.formatMoney(updatedTotalPrice, globalFieldsSub.amount) + '</span>');
            }
        }
    }
  
     var UpdateSavingMessage = function (isUpdate) {
        if (priceDiff > 0 && isUpdate && globalFieldsSub.isCartPage) {
            var saveMessage = globalFieldsSub.settings.cart_saving_message?.replace('{{discount_amount}}', '<span class="money" data-currency-' + globalFieldsSub.currency.toLowerCase() + '="' + globalFieldsSub.currencySymbol + priceDiff.toFixed(2) + '" data-currency="' + globalFieldsSub.currency + '">' + globalFieldsSub.formatMoney(priceDiff.toFixed(2), globalFieldsSub.amount) + '</span>');
            var saveHtml = '<span id="saved-banner">' + saveMessage + '</span>';
          if (jQuery(window).width() < 700) {
            //jQuery('#saved-banner-div').length == 0 ? jQuery('.js-contents .totals').after('<div id="saved-banner-div" style="text-align: center;" class="col-md-14">' + saveHtml + '</div>') : jQuery('#saved-banner-div').html(saveHtml);
          }
          else{
          //  jQuery('#saved-banner-div').length == 0 ? jQuery('.js-contents .totals').after('<div id="saved-banner-div" style="text-align: end;" class="col-md-14">' + saveHtml + '</div>') : jQuery('#saved-banner-div').html(saveHtml);
          }
        }
        else if (globalFieldsSub.isCartPage) {
            jQuery('#saved-banner-div').remove();
        }
    }
  
    var CheckoutClickCart = function () {
        // jQuery('.cart__footer .cart__ctas button[name="checkout"]').click(function () {
        //     // jQuery('[name="updates[]"]').each(function () {
        //     //     var qtyValue = this.value; var idAtrbtValue = jQuery(this).attr('id'); idAtrbtValue = idAtrbtValue.split('_'); idAtrbtValue = idAtrbtValue[1];
        //     //     idAtrbtValue = idAtrbtValue.split(':'); idAtrbtValue = idAtrbtValue[0];
        //     //     for (i = 0; i < globalFieldsSubtotalCartPage_AC.cartObj.items.length; i++) {
        //     //         if (globalFieldsSubtotalCartPage_AC.cartObj.items[i].variant_id == Number(idAtrbtValue)) { globalFieldsSubtotalCartPage_AC.cartObj.items[i].quantity = Number(qtyValue); }
        //     //     }
        //     // });
        //     TieredPricingCart(globalFieldsSubtotalCartPage_AC.cartObj, false);
        //     GetCode(false);
        // });
    }

    var CheckoutClickAjax = function () {
        // jQuery('.drawer__footer .cart__ctas button[name="checkout"]').click(function (e) {
        //     e.preventDefault();
        //     GetCode(true);
        // });
    }

    var GetCode = function (isUpper) {
        // if (priceDiff > 0) {
        //     $.ajax({
        //         type: "POST", async: false, url: "https://customerapp.anncode.com/tier/ACPGenerateCartCode",
        //       	data: { discountOff: priceDiff, subTotal: minimumDiscountSubtotal, discounType: "fixed_amount" },
        //         success: function (result) {
        //           try{
        //             if(result.status != 'error' || result.DiscountCode){
        //               var data_ = JSON.stringify(result); var parsed_data = JSON.parse(data_); var PRID = parsed_data.PRID;
        //               var DCID = parsed_data.DCID; var DiscountCode = parsed_data.DiscountCode;
        //               SetCookie("discountCodes", PRID + "-" + DCID + "-" + DiscountCode, 30);
        //               if (!isUpper) {
        //                   DiscountCodeCookie(DiscountCode);
        //                   jQuery('form[action="/cart"]').append('<input id="discount_input" type="hidden" name="discount" value="' + DiscountCode + '">');
        //               } else {
        //                   DiscountCodeCookie(DiscountCode);
        //                   //jQuery('form.cart-form').append('<input id="discount_input" type="hidden" name="discount" value="' + DiscountCode + '">');
        //                   window.location.href = '/checkout?discount=' + DiscountCode;
        //               }
        //             }
        //             else{ 
        //               window.location.href = '/checkout';
        //             }
        //           }
        //           catch(e){console.log(e);}
        //         },
        //         error: function (e) { console.log(e.statusText); }
        //     });
        // }
        // else if (isUpper) {
            window.location.href = '/checkout';
        // }
    }

    var ReInvokeAjaxCartButton = function () {
        jQuery('.mb_cart.mb_item button.btn, .top-header .dropdown-cart button.btn').off("click"); CheckoutClickAjax();
    }

    var variantIdsToSend = [], minimumDiscountSubtotal = 0, priceDiff = 0;
    var pendingCartUpdate = null;
    var pendingCartUpdateFrame = null;
    var pendingCartResponseFallback = null;

    var getRequestUrl = function (request) {
        if (typeof request === "string") return request;
        if (request && typeof request.url === "string") return request.url;
        return "";
    }

    var getCartPath = function (url) {
        try {
            return new URL(url, window.location.origin).pathname;
        } catch (e) {
            return (url || "").split("?")[0];
        }
    }

    var isCartJsonPath = function (path) {
        return path === "/cart.js" || path === "/cart/change.js" || path.endsWith("/cart.js") || path.endsWith("/cart/change.js");
    }

    var parseCartObject = function (cartResponse) {
        try {
            var parsedCart = typeof cartResponse === "string" ? JSON.parse(cartResponse) : cartResponse;
            return parsedCart && Array.isArray(parsedCart.items) ? parsedCart : null;
        } catch (e) {
            return null;
        }
    }

    var needsFreshTierData = function (cartObject) {
        var knownItems = {};
        var currentTierItems = globalFieldsSubtotalCartPage_AC.cartTiersArray || [];

        currentTierItems.forEach(function (tierItem) {
            if (tierItem && tierItem.item) {
                knownItems[tierItem.item.key || tierItem.item.id] = true;
            }
        });

        return (cartObject.items || []).some(function (item) {
            return !knownItems[item.key || item.id];
        });
    }

    var runAfterCartRender = function (callback) {
        if (window.requestAnimationFrame) {
            return window.requestAnimationFrame(callback);
        }

        return setTimeout(callback, 0);
    }

    var cancelAfterCartRender = function (frameId) {
        if (!frameId) return;

        if (window.cancelAnimationFrame) {
            window.cancelAnimationFrame(frameId);
        } else {
            clearTimeout(frameId);
        }
    }

    var refreshTieredPricingFromCart = function (cartObject, options) {
        if (!cartObject || !Array.isArray(cartObject.items)) return;

        pendingCartUpdate = {
            cartObject: cartObject,
            refreshTierData: !!(options && options.refreshTierData) || needsFreshTierData(cartObject)
        };

        cancelAfterCartRender(pendingCartUpdateFrame);
        pendingCartUpdateFrame = runAfterCartRender(function () {
            if (!pendingCartUpdate) return;

            var cartUpdate = pendingCartUpdate;
            pendingCartUpdate = null;
            pendingCartUpdateFrame = null;
            globalFieldsSubtotalCartPage_AC.cartObj = cartUpdate.cartObject;

            if (cartUpdate.refreshTierData) {
                FetchCartTiers();
            } else {
                TieredPricingCart(globalFieldsSubtotalCartPage_AC.cartObj, true);
                CheckoutClickCart();
                CheckoutClickAjax();
            }
        });
    }

    var queueCartResponseFallback = function (cartObject, options) {
        if (!cartObject || !Array.isArray(cartObject.items)) return;

        if (pendingCartResponseFallback) {
            clearTimeout(pendingCartResponseFallback);
        }

        pendingCartResponseFallback = setTimeout(function () {
            pendingCartResponseFallback = null;
            refreshTieredPricingFromCart(cartObject, options);
        }, 75);
    }

    var clearCartResponseFallback = function () {
        if (pendingCartResponseFallback) {
            clearTimeout(pendingCartResponseFallback);
            pendingCartResponseFallback = null;
        }
    }

    var TieredPricingCart = function (cartObject, isUpdate) {
           globalFieldsSubtotalCartPage_AC.cartTiersArray = excludeProductsOnTier();
          
      
        variantIdsToSend = []; minimumDiscountSubtotal = 0; priceDiff = 0; var updatedTotalPrice = 0; var actualTotalPrice = 0;
        var tierObj = globalFieldsSubtotalCartPage_AC.cartSubTotalMetafield;
         let DiscountAppliedOnTag = true;
          if(tierObj != undefined && tierObj != "[]"){
           DiscountAppliedOnTag = tierObj.DiscountAppliedON != undefined ?  tierObj.DiscountAppliedON == 'Both_Store' || tierObj.DiscountAppliedON == 'Online_Store' ? true : false : false;
          }else{
           DiscountAppliedOnTag = false; 
          }
        if (tierObj != undefined && tierObj != "[]" && tierObj.status && DiscountAppliedOnTag && globalFieldsSub.StartEndDateValid(tierObj.start_date, tierObj.end_date)) {
             progressBarMain();
            var calculatedTier = CalculateTierCartSubTotal(tierObj, globalFieldsSubtotalCartPage_AC.is_quantity_total, true);
            if (!calculatedTier[3]) {
                for (k = 0; k < globalFieldsSubtotalCartPage_AC.cartTiersArray.length; k++) {
                    var item = globalFieldsSubtotalCartPage_AC.cartTiersArray[k];
                    actualTotalPrice += globalFieldsSub.ConvertToFixedDecimalNumber(item.item.original_line_price / 100);
                    if (!item.is_exclude) {
                        variantIdsToSend.push(item.item.variant_id);
                    }
                    if (tierObj.discount_type == 'percentage') {
                        var rslt = CalculateTier(item.item, calculatedTier[2], tierObj, isUpdate, k);
                    }
                }
              minimumDiscountSubtotal = actualTotalPrice;
                updatedTotalPrice = actualTotalPrice - calculatedTier[5];
                UpdateCartSubtotal(isUpdate, globalFieldsSub.ConvertToFixedDecimalNumber(updatedTotalPrice), globalFieldsSub.ConvertToFixedDecimalNumber(actualTotalPrice));
                priceDiff = calculatedTier[5];
                UpdateSavingMessage(isUpdate);
            }

        }
    }

    var CalculateTierCartSubTotal = function (tiers, is_quantity_total, isNotInRange) {
        var eligibleItems = jQuery.grep(globalFieldsSubtotalCartPage_AC.cartTiersArray, function (n) { return !n.is_exclude; });
        var allVariantItemQty = 0;
        var eligibleSubtotal = 0;
        var discount_total = 0;
        
        for (j = 0; j < eligibleItems.length; j++) {
            allVariantItemQty += eligibleItems[j].item.quantity;
            eligibleSubtotal += globalFieldsSub.ConvertToFixedDecimalNumber(eligibleItems[j].item.original_line_price / 100);
        }
        var tierPrice = 0, minTier = 0, maxTier = '';
        for (i = 0; i < tiers.tier_min.length; i++) {
            tierPrice = parseFloat(tiers.tier_values[i]);
            minTier = parseFloat(tiers.tier_min[i]), maxTier = tiers.tier_max[i] != 'max' ? parseFloat(tiers.tier_max[i]) : tiers.tier_max[i];
            var condition1 = false, condition2 = false;
            if (is_quantity_total) {
                condition1 = allVariantItemQty >= minTier;
                condition2 = maxTier == "max" || allVariantItemQty <= maxTier;
            } else {
                condition1 = eligibleSubtotal >= minTier;
                condition2 = maxTier == "max" || eligibleSubtotal <= maxTier;
            }

            if (condition1 && condition2) {
                isNotInRange = false;
                if (tiers.discount_type == 'percentage') {
                    discount_total = parseFloat(globalFieldsSub.ConvertToFixedDecimalNumber((parseFloat(tierPrice) / 100) * globalFieldsSub.ConvertToFixedDecimalNumber(eligibleSubtotal)));
                }
                else if (tiers.discount_type == 'fixed') {
                    discount_total = globalFieldsSub.ConvertToFixedDecimalNumber(parseFloat(tierPrice));
                }
                break;
            }
        }
        return [minTier, maxTier, tierPrice, isNotInRange, eligibleSubtotal, discount_total];
    }

    var CalculateTier = function (item, tierPrice, itemTiers, isUpdate, index) {
        var updatedItemPrice = 0, updatedLinePrice = 0;
        if (itemTiers.discount_type == 'percentage') {
            var originalPriceCut = parseFloat(globalFieldsSub.ConvertToFixedDecimalNumber((parseFloat(tierPrice) / 100) * globalFieldsSub.ConvertToFixedDecimalNumber(item.original_price / 100)));
            updatedItemPrice = globalFieldsSub.ConvertToFixedDecimalNumber(globalFieldsSub.ConvertToFixedDecimalNumber(item.original_price / 100) - originalPriceCut);
        }
        //else if (itemTiers.discount_type == 'fixed') {
        //    updatedItemPrice = globalFieldsSub.ConvertToFixedDecimalNumber(globalFieldsSub.ConvertToFixedDecimalNumber(item.original_price / 100) - parseFloat(tierPrice));
        //}

        if (updatedItemPrice < 0) { updatedItemPrice = 0; }
        updatedLinePrice = globalFieldsSub.ConvertToFixedDecimalNumber(updatedItemPrice * item.quantity);
        UpdateCartItem(item, updatedItemPrice, updatedLinePrice, isUpdate, index);
    }

    var DiscountCodeCookie = function (discount_code) {
        $.ajax({
            type: "HEAD", url: "/discount/" + discount_code,
            success: function (_result) { },
            error: function (e) { console.log(e.statusText); }
        })
    }

    var FetchCartTiers = function () {

        jQuery.ajax({
            url: "/cart/?view=ac-cart_subtotal_tiers",
            success: function (result) {
                globalFieldsSubtotalCartPage_AC.cartTiersArray = JSON.parse(result);
                TieredPricingCart(globalFieldsSubtotalCartPage_AC.cartObj, true);
                CheckoutClickCart(); CheckoutClickAjax();
            },
            error: function (e) { console.log(e.statusText); }
        });
    }
    /*
        var open = window.XMLHttpRequest.prototype.open, send = window.XMLHttpRequest.prototype.send, onReadyStateChange;
        function openReplacement(method, url, async, user, password) { return open.apply(this, arguments); }
        function sendReplacement(data) {
            this.onreadystatechange = function () {
                if (this.readyState == 4 && this.status == 200) {
                    ProcessCartResponse(this._url, this.responseText);
                }
            };
            return send.apply(this, arguments);
        }
        window.XMLHttpRequest.prototype.open = openReplacement; window.XMLHttpRequest.prototype.send = sendReplacement;
    */

      var ProcessCartResponse = function (cartUrl, responseText) {
        if (cartUrl == 'undefined' || cartUrl == "" || cartUrl == null) return;

        var cartPath = getCartPath(cartUrl);
        if (!isCartJsonPath(cartPath)) return;

        var cartObject = parseCartObject(responseText);
        queueCartResponseFallback(cartObject);
    }


  
    jQuery(document).ajaxComplete(function (event, xhr, settings) {
        ProcessCartResponse(settings.url, xhr.responseText);
    });

    try {
        var nativeFetch = window.fetch;
        window.fetch = function (...args) {
            var requestUrl = getRequestUrl(args[0]);
            var requestPath = getCartPath(requestUrl);
            var isCartChangeRequest = requestPath.endsWith("/cart/change.js");
            var isCartAddRequest = requestPath.endsWith("/cart/add.js");
            var fetchResponse = nativeFetch.apply(window, args);

            if (isCartChangeRequest || isCartAddRequest) {
                fetchResponse.then(function (response) {
                    if (!response || !response.ok) return;

                    if (isCartChangeRequest) {
                        response.clone().json()
                            .then(function (cartObject) {
                                queueCartResponseFallback(parseCartObject(cartObject));
                            })
                            .catch(function () { });
                        return;
                    }

                    var cartJsonUrl = window.FoxTheme?.routes?.cart_url || '/cart';
                    cartJsonUrl = cartJsonUrl.endsWith('.js') ? cartJsonUrl : `${cartJsonUrl}.js`;
                    nativeFetch(cartJsonUrl, { headers: { 'X-Requested-With': 'XMLHttpRequest' } })
                        .then(function (cartResponse) { return cartResponse.json(); })
                        .then(function (cartObject) {
                            queueCartResponseFallback(parseCartObject(cartObject), { refreshTierData: true });
                        })
                        .catch(function () { });
                }).catch(function () { });
            }

            return fetchResponse;
        }
    }
    catch (e) { }

    document.addEventListener('cart:updated', function (event) {
        var cartObject = event && event.detail ? event.detail.cart : null;
        cartObject = parseCartObject(cartObject);
        if (!cartObject) return;

        clearCartResponseFallback();
        refreshTieredPricingFromCart(cartObject);
    });


    function excludeProductsOnTier() {
       let cartItems = globalFieldsSubtotalCartPage_AC.cartObj?.items || [];
        let excludeProducts = globalFieldsSubtotalCartPage_AC.cartSubTotalMetafield?.excludeProducts || [];
        let excludeTags = globalFieldsSubtotalCartPage_AC.cartSubTotalMetafield?.excludeTags || [];
        let cartTiersArray = Array.isArray(cartItems) && cartItems.length > 0 ? cartItems.map(item => {
            let isExcluded = Array.isArray(excludeProducts) && excludeProducts.some(exclude => exclude.id === item.product_id.toString());
            if (!isExcluded && Array.isArray(excludeTags) ) {
                 isExcluded = globalFieldsSubtotalCartPage_AC.cartTiersArray.some(excludeTag => item.id == excludeTag.item.id && excludeTag.is_exclude);
                }
            return { item: item, is_exclude: isExcluded };
        }) : [];
       return cartTiersArray
  }
 
  // Add event listener for page load to update the cart attribute
  window.addEventListener("load", async () => {
    await setDateTimeInCart();
  });

    var SetCookie = function (cname, cvalue, exdays) { var d = new Date(); d.setTime(d.getTime() + (exdays * 24 * 60 * 60 * 1000)); var expires = "expires=" + d.toUTCString(); document.cookie = cname + "=" + cvalue + ";" + expires + ";path=/"; }

    TieredPricingCart(globalFieldsSubtotalCartPage_AC.cartObj, true); CheckoutClickCart(); CheckoutClickAjax();
}

var globalFieldsSubtotalCartPage_AC = new ACDiscountAppSubtotal.CartPage.Global(); var cartObject = new ACDiscountAppSubtotal.CartPage.Show_CalculateTier();
